import React, { createContext, useContext, useState } from "react";

const defaultValue = {
  libraryId: null,
  setLibraryId: () => {},
  keyword: "",
  setKeyword: () => {},
};
// Create a context for the library state
const LibraryContext = createContext(defaultValue);

// Provider component to wrap around your application
export const LibraryProvider = ({ children }) => {
  const [libraryId, setLibraryId] = useState(null); // Default libraryId is null
  const [keyword, setKeyword] = useState("keyword");
  return (
    <LibraryContext.Provider
      value={{ libraryId, setLibraryId, keyword, setKeyword }}
    >
      {children}
    </LibraryContext.Provider>
  );
};

// Custom hook to use the context
export const useLibrary = () => useContext(LibraryContext);
